<template>
  <div>
    <div v-if="loading" class="has-text-centered" style="padding: 4rem 0;">
      <b-loading :active="loading" :is-full-page="false"></b-loading>
    </div>
    <div v-else-if="error" class="has-text-centered" style="padding: 4rem 0;">
      <h1 class="is-size-3" style="vertical-align: middle">
        404 Página no encontrada
      </h1>
    </div>
    <div v-else>
      <section v-if="!showResultsGuide" class="section-header">
        <div class="header-process">
          <img src="@/assets/logo_Mytho.png" alt="Mytho" class="logo-mytho" />
          <div class="divider"></div>
          <div>
            <h1 class="title is-4 truncate">
              {{ process.name || "-" }}
            </h1>
            <p class="subtitle is-6 truncate">
              {{ (process.idClient && process.idClient.nombre) || "-" }}
            </p>
          </div>
        </div>
      </section>

      <GuiaInterpretacion
        v-if="showResultsGuide"
        @continue="showResultsGuide = false"
      />
      <div v-else class="container">
        <Results />
      </div>
    </div>
  </div>
</template>

<script>
import Results from "../sections/results/Results.vue";
import GuiaInterpretacion from "../sections/results/GuiaInterpretacion.vue";
import store from "../store";
import { fetchProcessByIdShared } from "../api";

export default {
  name: "ShareCultura",
  components: { Results, GuiaInterpretacion },
  data() {
    return {
      loading: true,
      error: false,
      process: {},
      showResultsGuide: true,
    };
  },
  async created() {
    const { id } = this.$route.params;
    if (!id) {
      this.error = true;
      this.loading = false;
      return;
    }
    try {
      const process = await fetchProcessByIdShared(id);
      this.process = process;
      store.commit("SET_SELECTED_PROCESS", process);
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  },
  beforeDestroy() {
    store.commit("SET_SELECTED_PROCESS", null);
  },
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.section-header {
  padding: 3rem 4rem;
}

.header-process {
  display: flex;
  align-items: center;
  gap: 3rem;
}

.logo-mytho {
  width: 180px;
}

.divider {
  width: 0.1rem;
  height: 40px;
  background: #dbdbdb;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/views/ShareCultura.vue